import { useEnvVariables, useUser } from '@innovamat/ga-features';
import { useQuery } from '@tanstack/react-query';
import { GraphQLClient } from 'graphql-request';
import { PrintingToolModel } from '../api/printing-tool-model-document';
import type { PrintingTool } from '../types/printing-tool';

type PrintingToolModelResponse = {
  data: PrintingTool | undefined;
  error: Error | null;
};

function useGetPrintingToolModel(): PrintingToolModelResponse {
  const { PREPR_GRAPHQL: graphEndpoint } = useEnvVariables();
  const { user } = useUser();
  const userId = user?.id;

  const graphQLClient = new GraphQLClient(graphEndpoint, {
    headers: {
      'Prepr-Customer-Id': `${userId}`,
    },
  });

  const { data, error } = useQuery<PrintingTool, Error>({
    queryKey: ['printing-tool-model'],
    queryFn: () => graphQLClient.request(PrintingToolModel),
  });

  return { data, error };
}

export { useGetPrintingToolModel };
